module.exports = __webpack_public_path__ + "static/img/Olympic-Village.49abd3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Olympic-Village.jpg
// module id = XpnE
// module chunks = 0